export default "__VITE_ASSET__CYhWreY0__"